import { action, computed } from 'mobx'
import { type ScopeChangeRequest } from './ScopeChangeRequest'
import { type ScopeChangeRequestDetailsViewModel } from '@/features/admin/scope-change-requests/components/ScopeChangeRequestDetailsPanel/ScopeChangeRequestDetailsViewModel'

/**
 * A row in the scope change requests table.
 */
export class ScopeChangeRequestItemViewModel {
  constructor(
    readonly scopeChangeRequest: ScopeChangeRequest,
    private readonly _detailsVm: ScopeChangeRequestDetailsViewModel,
  ) {}

  /**
   * Whether the details panel shows this request.
   */
  @computed
  get isActive() {
    return this._detailsVm.scopeChangeRequest.id === this.scopeChangeRequest.id
  }

  /**
   * Shows the request in the details panel.
   */
  @action.bound
  select() {
    this._detailsVm.show(this.scopeChangeRequest)
  }
}
